import PropTypes from 'prop-types'

import GooglePlacesAutocompleteView from './View'

const propTypes = {
  changeAddress: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  defaultValue: PropTypes.string,
}

const GooglePlacesAutocomplete = ({
  changeAddress,
  // NOTE: códigos de país ISO 3166-1 Alpha-2, hasta 5: https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service?hl=es-419#ComponentRestrictions
  countries,
  ...props
}) => {
  const handleChangeAddress = address => {
    if (address === null) {
      changeAddress(null)
      return
    }

    const map = new window.google.maps.Map(
      document.getElementById('google-map-autocomplete'),
    )

    const payload = {
      placeId: address.place_id,
      fields: ['address_components', 'place_id', 'geometry.location'],
    }

    const service = new window.google.maps.places.PlacesService(map)

    service.getDetails(payload, (place, status) => {
      if (status === 'OK') {
        const postalCodeInfo = place.address_components.find(x =>
          x.types.includes('postal_code'),
        )
        const countryInfo = place.address_components.find(x =>
          x.types.includes('country'),
        )
        const streetInfo = place.address_components.find(x =>
          x.types.includes('route'),
        )
        const streetNumberInfo = place.address_components.find(x =>
          x.types.includes('street_number'),
        )

        const street = streetInfo?.long_name ?? ''
        const streetNumber = streetNumberInfo?.long_name ?? ''
        const address =
          streetNumber !== '' ? street.concat(', ', streetNumber) : street

        const newAddress = {
          address,
          place: place,
          postalCode: postalCodeInfo?.long_name ?? '',
          country: {
            label: countryInfo?.long_name ?? '',
            code: countryInfo?.short_name ?? '',
          },
          location: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          },
        }

        changeAddress(newAddress)
      }
    })
  }

  return (
    <GooglePlacesAutocompleteView
      {...props}
      changeAddress={handleChangeAddress}
      countries={countries.slice(0, 5)}
    />
  )
}

GooglePlacesAutocomplete.propTypes = propTypes

export default GooglePlacesAutocomplete
